import React, {useMemo, useEffect, useState, useRef } from 'react';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import { useTranslation } from "react-i18next";
import "../translations/i18n";
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { transLabel } from '../translations/util';
import DatePicker from 'rsuite/DatePicker';
import { getTasks, setTask } from '../Redux/actions/tasksServices';
import { useMsal} from '@azure/msal-react';
import { v4 as uuidv4 } from 'uuid';
import Message from "./message";
import ReactSelect from 'react-select';


const Tasking = () => {
  const [dataRow, setDataRow] = React.useState([]);
  const translations = useSelector(state => state.translationReducer);
  const caseRedux = useSelector(state => state.caseReducer);
  const [date, setDate] = React.useState(new Date());
  const [calendarOpen, setCalendarOpen] = React.useState(false);
  const { instance, accounts } = useMsal();
  const monthNames = ["ene", "feb", "mar", "abr", "may", "jun",
  "jul", "ago", "sep", "oct", "nov", "dic"
  ];

  const dayNames = ["Domingo", "Lunes", "Martes", "Miercoles", "Jueves", "Viernes", "Sabado"];
  const account = useMemo(() => accounts.filter(a => a.username.includes(process.env.REACT_APP_AAD_DOMAIN) || a.username.includes("atech-bpo")), [accounts])
  const usermail = (account!=null && account.length>0)?account[0].username==="jcmunozb.ext@ayesa.com"?"vmoctavio@ayesa.com":account[0].username:"";

  const msgRef = useRef();
  const [reload, setReload] = React.useState(false);

  const [initial, setInitial] = React.useState(false);
 
  console.log("instance",account);
  

  const [translation, setTranslation] = useState([]);
  const [taksAssings, setTaksAssings] = useState({});
  const [taskInfo, setTaksInfo] = useState({});
  const tipos = [
    {Id:"0", Name:"Seleccione"},
    {Id:"1337", Name:"Oficina"},
    {Id:"1338", Name:"En Cliente"},
    {Id:"1339", Name:"Teletrabajo "},
  ];

  const navigate = useNavigate();
  const toPage = (page) => {
    navigate(page)
  }

  const setTaks=(e)=>{
    taksAssings.map((element) =>{
      //alert(element.replicaHours);
      if(element.replicaHours!==0)
      {
        // alert(element.replicaTypeId+"  "+element.typeid);
       if(element.replicaTypeId!==element.typeid)
       {
        /* Add Replica */
        //alert("se mete");
          setTask("TimeEntries/TimeEntriesAdd", {
            "TimeEntries": [
              {
                "Id": 0,
                "IdProject": element.codigoProyecto,
                "ProjectDescription": element.descripcionProyecto,
                "IdIssue": element.codigoIssue,
                "IssueDescription": element.descripcionIssue,
                "UserName": usermail,
                "ActivityDescription": "",
                "Hours": element.replicaHours,
                "Spent_on": element.spent_on!=null?element.spent_on:date,
                "Comments": element.replicaComments,
                "Custom_fields": [
                  {
                    "id": 208,
                    "name": "Localización",
                    "value": element.replicaTypeId
                  }
                ],
                "IdUser":element.iduser,
                "IdActivity":40      
              }
            ]
          },function(response, error){ 
            if (response===null){
              msgRef.current.show(error.message,'Error al guardar','error');
              return;
            }
            msgRef.current.show('Se han actualizado las horas correctamente','Tasking','success');
            console.log("response add", response);
            setReload(!reload);
          });
        
      }else{
        element.hours=parseFloat(element.hours)+parseFloat(element.replicaHours);
      }
    }
      if (element.hourId==0){
        if (element.hours != element.hours_ori)
        {
          setTask("TimeEntries/TimeEntriesAdd", {
            "TimeEntries": [
              {
                "Id": 0,
                "IdProject": element.codigoProyecto,
                "ProjectDescription": element.descripcionProyecto,
                "IdIssue": element.codigoIssue,
                "IssueDescription": element.descripcionIssue,
                "UserName": usermail,
                "ActivityDescription": "",
                "Hours": element.hours,
                "Spent_on": element.spent_on!=null?element.spent_on:date,
                "Comments": element.comments,
                "Custom_fields": [
                  {
                    "id": 208,
                    "name": "Localización",
                    "value": element.typeid
                  }
                ],
                "IdUser":element.iduser,
                "IdActivity":40      
              }
            ]
          },function(response, error){ 
            if (response===null){
              msgRef.current.show(error.message,'Error al guardar','error');
              return;
            }
            msgRef.current.show('Se han actualizado las horas correctamente','Tasking','success');
            console.log("response add", response);
            setReload(!reload);
          });
        }
      }else{

        let typeId = element.custom_fields.find(c=>c.id==208).value;

        if (element.hours != element.hours_ori || typeId !=element.typeid || element.comments!=element.comments_ori)
        {

          element.custom_fields.map((field)=>{
            if (field.id==208){
              field.value=element.typeid;
            }
          });

          setTask("TimeEntries/TimeEntriesUpdate",{
            "Id": element.hourId,
            "hours": element.hours,
            "Comments": element.comments,
            "Spent_on": element.spent_on,
            "Activity": element.activity,
            "Custom_fields":element.custom_fields
          },function(response, error){ 
            if (response===null){
              msgRef.current.show(error.message,'Error al guardar','error');
              return;
            }
            msgRef.current.show('Se han actualizado las horas correctamente','Tasking','success');
            console.log("response update", response);
            setReload(!reload);
          });
        }
      }
    });
  }

  useEffect(() => {
    setDataRow(caseRedux.data);
  }, [caseRedux]);

  useEffect(() => {
    setTranslation(translations.data);
  }, [translations]);

  const setHour=(id, e, replica)=>{
    let index = taksAssings.findIndex(object => {
      return object.id === id;
    });
    const newFeatures = [...taksAssings];

    let ahours = 0;

    if (index !== -1) {
      let element = newFeatures[index];   
    if(replica === true){
      ahours =  parseFloat(element.replicaHours);
      element.replicaHours = e.target.value!=""? e.target.value:0;

      if (parseFloat(element.replicaHours)<0){
        msgRef.current.show('Debe ingresar un valor mayor o igual a cero','Error al ingresar las horas','error');
        e.target.value=ahours;
        element.replicaHours = ahours;
        return;
      }

    }else{
      ahours =  parseFloat(element.hours);
      element.hours = e.target.value!=""? e.target.value:0;

      if (parseFloat(element.hours)<0 || parseFloat(element.replicaHours)<0){
        msgRef.current.show('Debe ingresar un valor mayor o igual a cero','Error al ingresar las horas','error');
        e.target.value=ahours;
        element.hours =ahours;
     
        return;
      }
    }
      if ((taksAssings.reduce((a, b) => +a + +(parseFloat(b.hours)+parseFloat(b.replicaHours)), 0))>taskInfo.horasCalendario){
        msgRef.current.show('El total de horas no puede ser mayor al total planificado','Error al ingresar las horas','error');
        
        e.target.value=ahours;

        if(replica === true){
          element.replicaHours = ahours;
        }else{
          element.hours = ahours;
        }
       
      }
    }
    /*
    newFeatures.map((element) =>{
      element.propuesto=((taskInfo.horasCalendario-newFeatures.filter(c=>c.groupId==element.groupId)
      .reduce((a, b) => +a + +b.hours, 0))*element.propuesto_ori/100).toFixed(2)+" h";
      element.propuesto_cal=((taskInfo.horasCalendario-newFeatures.filter(c=>c.groupId==element.groupId)
      .reduce((a, b) => +a + +b.hours, 0))*element.propuesto_ori/100).toFixed(2)
    });*/


    taskInfo.horasCalculadas=taksAssings.reduce((a, b) => +a + +(parseFloat(b.hours)+parseFloat(b.replicaHours)), 0);
   
    setTaksInfo(taskInfo);

    setTaksAssings(newFeatures);
    setInitial(false);
  }

  const setType=(id, val, replica)=>{
    let index = taksAssings.findIndex(object => {
      return object.id === id;
    });
    const newFeatures = [...taksAssings];
    if (index !== -1) {
      let element = newFeatures[index];
      if (replica === true){
        newFeatures[index].replicaTypeId =  val;
      }else{
        element.typeid =  val;
      }
    
    }
    setTaksAssings(newFeatures);
    setInitial(false);
  }

  const setComments=(id, val, replica)=>{
    let index = taksAssings.findIndex(object => {
      return object.id === id;
    });
    const newFeatures = [...taksAssings];
    if (index !== -1) {
      let element = newFeatures[index];
      if (replica === true){
        newFeatures[index].replicaComments =  val;
      }else{
        element.comments =  val;
      }
    
    }
    setTaksAssings(newFeatures);
    setInitial(false);
  }

const setReplica=(id)=>{
    let index = taksAssings.findIndex(object => {
      return object.id === id;
    });
   const newFeatures = [...taksAssings];
  if (index !== -1) {
      let element = newFeatures[index];

      element.replicaTypeId = element.typeid;
      element.replicaHours = 0;
      element.replicaComments = "";
    
    /*newFeatures.push({
      codigoProyecto:element.codigoProyecto,
      descripcionProyecto:element.descripcionProyecto,
      codigoIssue:element.codigoIssue,
      descripcionIssue:element.descripcionIssue,
      idActivity:element.idActivity,
      propuesto:element.propuesto,
      historico:element.propuesto + " %",
      origen:element.origen,
      hours:0,
      tipo:"Oficina",
      typeid:1337,
      propuesto_ori:element.propuesto,
      hourId:0,
      id: uuidv4(),
      groupId: uuidv4(),
      propuesto_cal:element.propuesto,
      spent_on:null,
      hours_ori:0,
      comments:"",
      activity:null,
      custom_fields:[],
      iduser:element.iduser,
      replica:""
    });*/
  }

    setTaksAssings(newFeatures);
    setInitial(false);
}
/*useEffect(() => {
  setTaksAssings(taksAssings);
}, [taksAssings]); */

const getPreviousDate = (selectedDate) => {
  //const { selectedDate } = this.state

  const currentDayInMilli = new Date(selectedDate).getTime()
  const oneDay = 1000 * 60 *60 *24
  const previousDayInMilli = currentDayInMilli - oneDay
  const previousDate = new Date(previousDayInMilli)

  setDate(previousDate)

}

const getNextDate = (selectedDate) => {
  //const { selectedDate } = this.state

  const currentDayInMilli = new Date(selectedDate).getTime()
  const oneDay = 1000 * 60 *60 *24
  const nextDayInMilli = currentDayInMilli + oneDay
  const nextDate = new Date(nextDayInMilli)

  setDate(nextDate)

}

  useEffect(() => {
    getTasks("TimeEntries", {
      "date": date,
      "mail": usermail
    },function(response, error){ 

      if (response===null){
        msgRef.current.show(error.message,'Error al consultar datos','error');
        return;
      }else if (response.textoRetorno!=undefined && response.textoRetorno!="OK!"){
        msgRef.current.show(response.textoRetorno,'Error al consultar datos','error');
        return;
      }

      let newData = [];
      response.asignaciones.sort((a, b) => a.propuesto < b.propuesto ? 1 : -1).map((element) =>{
          element.hours=0;
          if (element.horaReales.length>0)
          {
              let groupId =  uuidv4();
              element.horaReales.map((hour)=>{
                let typeId = hour.custom_fields.find(c=>c.id==208).value;
                let tipo = "";

                if (typeId==1337){
                  tipo = "Oficina";
                }else  if (typeId==1338){
                  tipo = "Oficina";
                }else  if (typeId==1339){
                  tipo = "Oficina";
                }else {
                  tipo = "Oficina";
                  typeId=1337
                }

                newData.push({
                codigoProyecto:element.codigoProyecto,
                descripcionProyecto:element.descripcionProyecto,
                codigoIssue:element.codigoIssue,
                descripcionIssue:element.descripcionIssue,
                idActivity:element.idActivity,
                propuesto:((response.horasCalendario)*element.propuesto/100).toFixed(2)+" h",
                historico:element.propuesto + " %",
                origen:element.origen,
                hours:hour.hours,
                tipo:tipo,
                typeid:typeId,
                propuesto_ori:element.propuesto,
                hourId:hour.id,
                id: uuidv4(),
                groupId: groupId,
                propuesto_cal:((response.horasCalendario-element.horaReales.reduce((a, b) => +a + +b.hours, 0))*element.propuesto/100).toFixed(2),
                spent_on:hour.spent_on,
                hours_ori:hour.hours,
                comments:hour.comments,
                comments_ori:hour.comments,
                activity:hour.activity,
                custom_fields:hour.custom_fields,
                iduser:response.iduser,
                replicaTypeId:typeId,
                replicaHours:0,
                replicaComments:""
              });
            });
          }else {
            newData.push({
              codigoProyecto:element.codigoProyecto,
              descripcionProyecto:element.descripcionProyecto,
              codigoIssue:element.codigoIssue,
              descripcionIssue:element.descripcionIssue,
              idActivity:element.idActivity,
              propuesto:(response.horasCalendario*element.propuesto/100).toFixed(2)+" h",
              historico:element.propuesto + " %",
              origen:element.origen,
              hours:0,
              tipo:"Oficina",
              typeid:1337,
              propuesto_ori:element.propuesto,
              hourId:0,
              id: uuidv4(),
              groupId: uuidv4(),
              propuesto_cal:(response.horasCalendario*element.propuesto/100).toFixed(2),
              spent_on:null,
              hours_ori:0,
              comments:"",
              comments_ori:"",
              activity:null,
              custom_fields:[],
              iduser:response.iduser,
              replicaTypeId:1337,
              replicaHours:0,
              replicaComments:""

            });
          }
      });
      console.log("newData",newData);
      setTaksInfo({
        codigoRetorno:response.codigoRetorno,
        textoRetorno:response.textoRetorno,
        iduser:response.iduser,
        horasCalendario:response.horasCalendario,
        horasCalculadas:newData.reduce((a, b) => +a + +parseFloat(b.hours), 0)
      });
      setTaksAssings(newData);
      setInitial(true);
    });
  }, [date, reload]);

  const { t } = useTranslation();
    
    return (
      <>
        <Header />
       {/* ======= Banner ======= */}
       <div id="banner" className="container sticky-thc">
          <div className="row" style={{backgroundColor:'#FFFFFF'}}>
            <div className="col-md-5 left">
              <div className="float-start">
                <h1>{dayNames[date.getDay()]}, {date.getDate()} {monthNames[date.getMonth()]}.</h1>
              </div>
              </div>
              <div className="col-md-2 left">
              <div className="float-start">
                <table style={{width:"100%"}}>
                  <tr>
                    <td>
                      <button className="rounded-circle btn btn-light" onClick={() => getPreviousDate(date)}> <span className="icons-theader" style={{fontWeight: 600}}>arrow_left</span></button>
                    </td>
                    <td><button id="calendar-button" className="rounded-circle btn btn-light"
                    onClick={()=>setCalendarOpen(true)} 
                      onBlur={()=>{
                          setTimeout(() => {
                          setCalendarOpen(false);
                          }, 1000)
                      } 
                     }
                    /></td>
                    <td>
                        <button className="rounded-circle btn btn-light" onClick={() => getNextDate(date)}> <span className="icons-theader" style={{fontWeight: 600}}>arrow_right</span></button>
                    </td>
                    <td>
                    <DatePicker
                      isoWeek
                      oneTap={true}
                      format="dd/MMM/yyyy"
                      style={{ visibility: "hidden" }}
                      locale={{
                        sunday: 'Dom',
                        monday: 'Lun',
                        tuesday: 'Mar',
                        wednesday: 'Mie',
                        thursday: 'Jue',
                        friday: 'Vie',
                        saturday: 'Sab',
                        ok: 'OK',
                        today: 'Hoy',
                        yesterday: 'Ayer',
                        hours: 'Horas',
                        minutes: 'Minutos',
                        seconds: 'Segundos'
                      }}
                      value={date} onChange={(val)=>{
                        setDate(val);
                        setCalendarOpen(false);
                      }}
                      open={calendarOpen} 
                    />
                    </td>
                  </tr>
                </table>
              </div>
            </div>
            {/*Çdiv className="col-md-4">
              <button className="btn btn-light btn-lg float-end desktop planning">Planificación mensual <span className="calendar-month" /></button>
             </div>*/}
              <div className="col" style={{padding:'0'}}>
              <div className="container-fluid" style={{paddingTop:'25px'}}>
                <div id="total" className="float-end desktop" >
                  <p>{taskInfo.horasCalculadas?.toFixed(2)}</p>
                </div>
                <div id="total_smartphone" className="float-end smartphone" style={{paddingTop:'-40px'}}>
                  <p className="check_circle" style={{fontSize:'1.3em'}}><span style={{fontWeight: 600}}>TOTAL</span><span style={{fontSize:'1.5em',fontWeight: 900}}>{taskInfo.horasCalculadas?.toFixed(2)}</span></p>
                </div>
                <div className="float-start smartphone"style={{fontSize:'1.2em',paddingTop:'10px'}}>
                  <p className="pending_actions">Planificado {taskInfo.horasCalendario} h</p>
                </div>
                <div className="float-end ms-5 desktop">
                  <p className="check_circle" style={{fontSize:'1.0em'}}><span style={{fontWeight: 600}}>TOTAL</span></p>
                </div>
                <div className="float-end desktop">
                  <p className="pending_actions">Planificado {taskInfo.horasCalendario} h</p>
                </div>

          </div>
        </div>   

          </div>
          <div className="row" style={{backgroundColor:'transparent'}}>
              <div className="col">
                <div className="float-end desktop" style={{marginTop:'-35px'}}>
                  <button type="button" className="btn btn-primary btn-lg" onClick={(e)=>setTaks(e)}>Enviar a Tasking <span className="sending" /></button>
                </div>
                <div className="d-grid smartphone">
                  <button type="button" className="btn btn-primary btn-lg" onClick={(e)=>setTaks(e)}>Enviar a Tasking</button>
                </div>
              </div>
            </div>
        </div>{/* End Banner */}
        {/* ======= Smartphone ======= */}
        <div className="container no-tablet smartphone">
          <div className="row">
            <div className="col-8" style={{fontSize: '1.2rem'}}><span className="icons-theader">task_alt</span> Tareas</div>
            <div className="col-4" style={{fontSize: '1.2rem'}}>
            <span className="icons-theader" style={{marginLeft:'35px'}}>watch_later</span> 
            <span style={{fontWeight: 600}}>h/m</span></div>
          </div>
          {taksAssings?.length>0 && taksAssings.filter(c=>c.propuesto_ori>0).map((element) =>
              <div className="row task"  key={element.id}>
                <div className="col-8">
                  <p><span className="task-name">{element.descripcionIssue}</span>
                    <br />#{element.codigoIssue}
                    <br /><span className="task-code">{element.descripcionProyecto}</span> 
                    <br /><span style={{fontSize:'1.2em'}}>{element.historico}</span>
                    <br /><span className="task-time" style={{fontSize:'1.2em'}}>{element.propuesto}</span>
                    <br />
                    <div className="input-group">
              <textarea name={"comment_"+ element.id}
                    id={"comment_"+ element.id}
                    className="form-control"
                    placeholder="Comentarios"
                    defaultValue={element.comments}
                    onChange={(e)=>{
                      setComments(element.id,e.target.value,false);
                    }}
                  rows="1"
                  style={{ textAlign: 'left',fontSize:'1px'}} >
                    
                  </textarea>
              </div>
                    </p>
                </div>
                <div className="col-4 col-time" style={{ textAlign: 'right'}}>
                  <p>
                    <input className="form-control" style={{padding:"0px",marginLeft:'35px'}} type="number" defaultValue={element.hours} defaultChecked={element.hours} onFocus={(e)=>{e.target.value=(e.target.value=="0")?"":e.target.value}}  onChange={(e)=>setHour(element.id, e,false)}  aria-label=".form-control example"/><br/>
                    <ReactSelect
                        options = {tipos}
                        defaultValue={tipos.filter(list => list.Id ==element.typeid)}
                        getOptionLabel={option => option['Name']}
                        getOptionValue={option => option['Id']}
                        onChange={(e)=>{
                          setType(element.id, e.Id,false);
                        }} 
                        isSearchable={false}   
                        className="select-tipo"                      
                      />
                  {
                    element.id!=0  &&
                    <div className="col-1 left">
                      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={"#collapse_"+ element.id} aria-expanded="false" aria-controls={"collapse_"+ element.id} onClick={()=>setReplica(element.id)}>
                          <span className="icons-theader">shuffle</span>
                      </button>
                    </div>                    
                  }
                  </p>
                </div>
                {/* Accordion Replica Smartphone*/}
                <div className="accordion">
          <div className="accordion-item">
            <h2 className="accordion-header" id={"heading_" + element.id}>
    
            </h2>
            <div id={"collapse_"+ element.id} className="accordion-collapse collapse" aria-labelledby={"heading_" + element.id} data-bs-parent="#accordionExample">
              <div className="accordion-body">
              <div className="row task"  key={element.id}>
                <div className="col-8">
                  <p><span className="task-name">{element.descripcionIssue}</span>
                  <br />#{element.codigoIssue}
                    <br /><span className="task-code">{element.descripcionProyecto}</span> 
                    <br /><span style={{fontSize:'1.2em'}}>{element.historico}</span>
                    <br /><span className="task-time" style={{fontSize:'1.2em'}}>{element.propuesto}</span>
                    <br />
                    <div className="input-group">
              <textarea name={"comment_"+ element.id}
                    id={"comment_"+ element.id}
                    className="form-control"
                    placeholder="Comentarios"
                    defaultValue={element.replicaComments}
                    onChange={(e)=>{
                      setComments(element.id,e.target.value,true);
                    }}
                  rows="1"
                  style={{ textAlign: 'left',fontSize:'100%'}} >
                    
                  </textarea>
              </div>
                    </p>
                </div>
                <div className="col-4 col-time" style={{ textAlign: 'right'}}>
                  <p>
                    <input className="form-control" style={{padding:"0px",marginLeft:'35px'}} type="number" defaultChecked={element.replicaHours} onFocus={(e)=>{e.target.value=(e.target.value=="0")?"":e.target.value}}  onChange={(e)=>setHour(element.id, e,true)}  defaultValue={element.replicaHours} aria-label=".form-control example" /><br/>
                      <ReactSelect
                      options = {tipos}
                      defaultValue={tipos.filter(list => list.Id == element.replicaTypeId)}
                      getOptionLabel={option => option['Name']}
                      getOptionValue={option => option['Id']}
                      onChange={(e)=>{
                        setType(element.id, e.Id,true);
                      }} 
                      isSearchable={false}
                      className="select-tipo"  
                    />
                  </p>
                </div>
                </div>
              </div>
              </div>
            </div>
          </div>{/*End Accordion Replica Smartphone*/}
        </div>
          )}
          {/* ======= Accordion ======= */}
          <div className="accordion">
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingOne">
                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                  Ver más tareas
                </button>
              </h2>
              <div id="collapseOne" className="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                <div className="accordion-body">
                {taksAssings?.length>0 && taksAssings.filter(c=>c.propuesto_ori<=0).map((element) =>
              <div className="row task"  key={element.id}>
                <div className="col-8">
                  <p><span className="task-name">{element.descripcionIssue}</span>
                  <br />#{element.codigoIssue}
                    <br /><span className="task-code">{element.descripcionProyecto}</span> 
                    <br /><span style={{fontSize:'1.2em'}}>{element.historico}</span>
                    <br /><span className="task-time" style={{fontSize:'1.2em'}}>{element.propuesto}</span>
                    <br />
                    <div className="input-group">
              <textarea name={"comment_"+ element.id}
                    id={"comment_"+ element.id}
                    className="form-control"
                    placeholder="Comentarios"
                    defaultValue={element.comments}
                    onChange={(e)=>{
                      setComments(element.id,e.target.value,false);
                    }}
                  rows="1"
                  style={{ textAlign: 'left',fontSize:'70%'}} >
                    
                  </textarea>
              </div></p>
                </div>
                <div className="col-4 col-time" style={{ textAlign: 'right'}}>
                  <p>
                    <input className="form-control" style={{padding:"0px",marginLeft:'35px'}} type="number" defaultChecked={element.hours} defaultValue={element.hours}
                    onFocus={(e)=>{e.target.value=(e.target.value=="0")?"":e.target.value}} 
                    onChange={(e)=>setHour(element.id, e, false)}  aria-label=".form-control example" /><br/>
                    <ReactSelect
                        options = {tipos}
                        defaultValue={tipos.filter(list => list.Id ==element.typeid)}
                        getOptionLabel={option => option['Name']}
                        getOptionValue={option => option['Id']}
                        onChange={(e)=>{
                          setType(element.id, e.Id,false);
                        }} 
                        isSearchable={false}   
                        className="select-tipo"                      
                      />
                  {
                    element.id!=0  &&
                    <div className="col-1 left">
                      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={"#collapse_"+ element.id} aria-expanded="false" aria-controls={"collapse_"+ element.id} onClick={()=>setReplica(element.id)}>
                          <span className="icons-theader">shuffle</span>
                      </button>
                    </div>                    
                  }
                  </p>
                </div>
          {/* Accordion Replica Accordion Smartphone*/}
        <div className="accordion">
          <div className="accordion-item">
            <h2 className="accordion-header" id={"heading_" + element.id}>
    
            </h2>
            <div id={"collapse_"+ element.id} className="accordion-collapse collapse" aria-labelledby={"heading_" + element.id} data-bs-parent="#accordionExample">
              <div className="accordion-body">
              <div className="row task"  key={element.id}>
                <div className="col-8">
                  <p><span className="task-name">{element.descripcionIssue}</span>
                  <br />#{element.codigoIssue}
                    <br /><span className="task-code">{element.descripcionProyecto}</span> 
                    <br /><span style={{fontSize:'1.2em'}}>{element.historico}</span>
                    <br /><span className="task-time" style={{fontSize:'1.2em'}}>{element.propuesto}</span>
                    <br />
                    <div className="input-group">
              <textarea name={"comment_"+ element.id}
                    id={"comment_"+ element.id}
                    className="form-control"
                    placeholder="Comentarios"
                    defaultValue={element.replicaComments}
                    onChange={(e)=>{
                      setComments(element.id,e.target.value,true);
                    }}
                  rows="1"
                  style={{ textAlign: 'left',fontSize:'70%'}} >
                    
                  </textarea>
              </div></p>
                </div>
                <div className="col-4 col-time" style={{ textAlign: 'right'}}>
                  <p>
                    <input className="form-control" style={{padding:"0px",marginLeft:'35px'}} type="number" defaultChecked={element.replicaHours} onFocus={(e)=>{e.target.value=(e.target.value=="0")?"":e.target.value}}  onChange={(e)=>setHour(element.id, e,true)}  defaultValue={element.replicaHours} aria-label=".form-control example" /><br/>
                      <ReactSelect
                      options = {tipos}
                      defaultValue={tipos.filter(list => list.Id == element.replicaTypeId)}
                      getOptionLabel={option => option['Name']}
                      getOptionValue={option => option['Id']}
                      onChange={(e)=>{
                        setType(element.id, e.Id,true);
                      }} 
                      isSearchable={false}
                      className="select-tipo"  
                    />
                  </p>
                </div>
                </div>
              </div>
              </div>
            </div>
          </div>{/*End Accordion Replica Accordion Smartphone*/}
              </div>
          )}
                </div>
              </div>
            </div>
          </div>{/*End Accordion*/}
        </div>{/*End Smartphone*/}
        {/* ======= Desktop ======= */}
        <div id="fijo" className="container desktop pb-5">
          <div className="row list-theader">
            <div className="col-3 left">
              <span className="icons-theader">task_alt</span> Tareas
            </div>
            <div className="col-2 left" style={{height: '60px', verticalAlign: 'middle'}}>
              <span className="icons-theader no-tablet">manage_history</span> Histórico
            </div>
            <div className="col-2 left" style={{height: '60px', verticalAlign: 'middle'}}>
              <span className="icons-theader no-tablet">update</span> Propuesta
            </div>
            <div className="col-2 left" style={{height: '60px', verticalAlign: 'middle'}}>
              <span className="icons-theader no-tablet">update</span> Tipo
            </div>
            <div className="col-2 left" style={{height: '60px', verticalAlign: 'middle'}}>
              <span className="icons-theader">watch_later</span> <span style={{fontWeight: 600}}>h/m</span>
            </div>
            <div className="col-1 left" style={{height: '60px', verticalAlign: 'middle'}}>
             
            </div>
          </div>
          {taksAssings?.length>0 && taksAssings.filter(c=>c.propuesto_ori>0).map((element) =>
                <div className="row align-items-center py-2 task"  key={element.id}>
                  <div className="col-3">
                    <span className="project">#{element.codigoIssue} {element.descripcionIssue} </span> <span className="code-project">{element.descripcionProyecto}</span><br />
                    
                  </div>
                  <div className="col-2 left">
                    <span className="history-date">{element.historico}</span>
                  </div>
                  <div className="col-2 left">
                    <span className="history-date">{element.propuesto}</span>
                  </div>
                  <div className="col-2 left">
                    <span className="history-date"> <ReactSelect
                        options = {tipos}
                        defaultValue={tipos.filter(list => list.Id ==element.typeid)}
                        getOptionLabel={option => option['Name']}
                        getOptionValue={option => option['Id']}
                        onChange={(e)=>{
                          setType(element.id, e.Id,false);
                        }} 
                        isSearchable={false} 
                      /></span>
                  </div>
                  <div className="col-2 left">
                    <span><input className="form-control" type="number" defaultChecked={element.hours} onFocus={(e)=>{e.target.value=(e.target.value=="0")?"":e.target.value}}  onChange={(e)=>setHour(element.id,e,false)}  defaultValue={element.hours} aria-label=".form-control example" /><span className="form-control" style={{backgroundColor:"transparent"}}>{element.hours>0?"*":""}</span></span>
                  </div>
                  {
                    element.id!=0  &&
                    <div className="col-1 left">
                      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={"#collapse_"+ element.id} aria-expanded="false" aria-controls={"collapse_"+ element.id} onClick={()=>setReplica(element.id)}>
                          <span className="icons-theader">shuffle</span>
                      </button>
                    </div>                    
                  }
            <div className="input-group">
              <textarea name={"comment_"+ element.id}
                    id={"comment_"+ element.id}
                    className="form-control"
                    placeholder="Comentarios"
                  defaultValue={element.comments}
                  onChange={(e)=>{
                    setComments(element.id,e.target.value,false);
                  }} 
                  rows="1"
                  style={{ textAlign: 'left',fontSize:'100%'}} >
                    
                  </textarea>
              </div>
            {/* Accordion Replica Desktop*/}
          <div className="accordion">
          <div className="accordion-item">
            <h2 className="accordion-header" id={"heading_" + element.id}>
    
            </h2>
            <div id={"collapse_"+ element.id} className="accordion-collapse collapse" aria-labelledby={"heading_" + element.id} data-bs-parent="#accordionExample">
              <div className="accordion-body">
              <div className="row align-items-center py-2 task" key={element.id}>
                <div className="col-3">
                  <span className="project">#{element.codigoIssue} {element.descripcionIssue}</span> <span className="code-project">{element.descripcionProyecto}</span><br />
                
                </div>
                <div className="col-2 left">
                  <span className="history-date">{element.historico}</span>
                </div>
                <div className="col-2 left">
                  <span className="history-date">{element.propuesto}</span>
                </div>
                <div className="col-2 left">
                  <span className="history-date"> <ReactSelect
                      options = {tipos}
                      defaultValue={tipos.filter(list => list.Id == element.replicaTypeId)}
                      getOptionLabel={option => option['Name']}
                      getOptionValue={option => option['Id']}
                      onChange={(e)=>{
                        setType(element.id, e.Id,true);
                      }} 
                      isSearchable={false} 
                    /></span>
                </div>
                <div className="col-2 left">
                  <span><input className="form-control" type="number" defaultChecked={element.replicaHours} onFocus={(e)=>{e.target.value=(e.target.value=="0")?"":e.target.value}}  onChange={(e)=>setHour(element.id, e,true)}  defaultValue={element.replicaHours} aria-label=".form-control example" /><span className="form-control" style={{backgroundColor:"transparent"}}>{element.replicaHours>0?"*":""}</span></span>
                </div>
                  <div className="col-1 left">
                      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={"#collapse_"+ element.id} aria-expanded="false" aria-controls={"collapse_"+ element.id} style={{visibility:"hidden"}}>
                          <span className="icons-theader">shuffle</span>
                      </button>
                  </div>
            <div className="input-group">
              <textarea name={"comment_"+ element.id}
                    id={"comment_"+ element.id}
                    className="form-control"
                    placeholder="Comentarios"
                    defaultValue={element.replicaComments}
                    onChange={(e)=>{
                      setComments(element.id,e.target.value,true);
                    }} 
                  rows="1"
                  style={{ textAlign: 'left',fontSize:'100%',paddingTop:'10px'}} >
                    
                  </textarea>
              </div>
                </div>
              </div>
            </div>
          </div>
        </div>{/*End Accordion Desktop*/}
      </div>
          )}
          {/* ======= Accordion ======= */}
          <div className="accordion">
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingOne">
                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                  Ver más tareas
                </button>
              </h2>
              <div id="collapseOne" className="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                <div className="accordion-body">
                {taksAssings?.length>0 && taksAssings.filter(c=>c.propuesto_ori<=0).map((element) =>
                <div className="row align-items-center py-2 task" key={element.id}>
                  <div className="col-3">
                    <span className="project">#{element.codigoIssue} {element.descripcionIssue}</span> <span className="code-project">{element.descripcionProyecto}</span><br />
                
                  </div>
                  <div className="col-2 left">
                    <span className="history-date">{element.historico}</span>
                  </div>
                  <div className="col-2 left">
                    <span className="history-date">{element.propuesto}</span>
                  </div>
                  <div className="col-2 left">
                    <span className="history-date"> <ReactSelect
                        options = {tipos}
                        defaultValue={tipos.filter(list => list.Id ==element.typeid)}
                        getOptionLabel={option => option['Name']}
                        getOptionValue={option => option['Id']}
                        onChange={(e)=>{
                          setType(element.id, e.Id,false);
                        }} 
                        isSearchable={false} 
                      /></span>
                  </div>
                  <div className="col-2 left">
                    <span><input className="form-control" type="number" defaultChecked={element.hours} onFocus={(e)=>{e.target.value=(e.target.value=="0")?"":e.target.value}}  onChange={(e)=>setHour(element.id,e,false)}  defaultValue={element.hours} aria-label=".form-control example" /><span className="form-control" style={{backgroundColor:"transparent"}}>{element.hours>0?"*":""}</span></span>
                  </div>
                  {
                    element.id!=0  &&
                    <div className="col-1 left">
                      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={"#collapse_"+ element.id} aria-expanded="false" aria-controls={"collapse_"+ element.id} onClick={()=>setReplica(element.id)}>
                          <span className="icons-theader">shuffle</span>
                      </button>
                    </div>                    
                  }
            <div className="input-group">
              <textarea name={"comment_"+ element.id}
                    id={"comment_"+ element.id}
                    className="form-control"
                    placeholder="Comentarios"
                    defaultValue={element.comments}
                    onChange={(e)=>{
                      setComments(element.id,e.target.value,false);
                    }} 
                  rows="1"
                  style={{ textAlign: 'left',fontSize:'100%'}} >
                    
                  </textarea>
              </div>
          {/* Accordion Replica Accordion*/}
          <div className="accordion">
          <div className="accordion-item">
            <h2 className="accordion-header" id={"heading_" + element.id}>
    
            </h2>
            <div id={"collapse_"+ element.id} className="accordion-collapse collapse" aria-labelledby={"heading_" + element.id} data-bs-parent="#accordionExample">
              <div className="accordion-body">
              <div className="row align-items-center py-2 task" key={element.id}>
                <div className="col-3">
                  <span className="project">#{element.codigoIssue} {element.descripcionIssue}</span> <span className="code-project">{element.descripcionProyecto}</span><br />
                 
                </div>
                <div className="col-2 left">
                  <span className="history-date">{element.historico}</span>
                </div>
                <div className="col-2 left">
                  <span className="history-date">{element.propuesto}</span>
                </div>
                <div className="col-2 left">
                  <span className="history-date"> <ReactSelect
                      options = {tipos}
                      defaultValue={tipos.filter(list => list.Id == element.replicaTypeId)}
                      getOptionLabel={option => option['Name']}
                      getOptionValue={option => option['Id']}
                      onChange={(e)=>{
                        setType(element.id, e.Id,true);
                      }} 
                      isSearchable={false} 
                    /></span>
                </div>
                <div className="col-2 left">
                  <span><input className="form-control" type="number" defaultChecked={element.replicaHours} onFocus={(e)=>{e.target.value=(e.target.value=="0")?"":e.target.value}}  onChange={(e)=>setHour(element.id, e,true)}  defaultValue={element.replicaHours} aria-label=".form-control example" /><span className="form-control" style={{backgroundColor:"transparent"}}>{element.replicaHours>0?"*":""}</span></span>
                </div>
                  <div className="col-1 left">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={"#collapse_"+ element.id} aria-expanded="false" aria-controls={"collapse_"+ element.id} style={{visibility:"hidden"}}>
                          <span className="icons-theader">shuffle</span>
                      </button>
                  </div>
                  <div className="input-group">
                    <textarea name={"comment_"+ element.id}
                    id={"comment_"+ element.id}
                    className="form-control"
                    placeholder="Comentarios"
                    defaultValue={element.replicaComments}
                    onChange={(e)=>{
                      setComments(element.id,e.target.value,true);
                    }} 
                  rows="1"
                  style={{ textAlign: 'left',fontSize:'100%'}} >
                    
                  </textarea>
              </div>
                </div>
              </div>
            </div>
          </div>
        </div>{/*End Accordion Accordion*/}
                </div>
                )}
                </div>
              </div>
            </div>
          </div>{/*End Accordion*/}
        </div> {/* End Desktop */}
        {/* ======= Sending information to Tasking ======= */}
        <div id="addition" className="container-fluid">
          <div className="container">
            <div className="row">
              <div className="col">
              <div id="total" className="float-end desktop" >
                  <p>{taskInfo.horasCalculadas?.toFixed(2)}</p>
                </div>
                <div id="total_smartphone" className="float-end smartphone" style={{paddingTop:'-40px'}}>
                  <p className="check_circle" style={{fontSize:'0.9em'}}><span style={{fontWeight: 600}}>TOTAL</span><span style={{fontSize:'1.5em',fontWeight: 900}}>{taskInfo.horasCalculadas?.toFixed(2)}</span></p>
                </div>
                <div className="float-start smartphone"style={{fontSize:'0.9em',paddingTop:'10px'}}>
                  <p className="pending_actions">Planificado {taskInfo.horasCalendario} h</p>
                </div>
                <div className="float-end ms-5 desktop">
                  <p className="check_circle" style={{fontSize:'1.0em'}}><span style={{fontWeight: 600}}>TOTAL</span></p>
                </div>
                <div className="float-end desktop">
                  <p className="pending_actions">Planificado {taskInfo.horasCalendario} h</p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col">
                <div className="float-end desktop">
                  <button type="button" className="btn btn-primary btn-lg" onClick={(e)=>setTaks(e)}>Enviar a Tasking <span className="sending" /></button>
                </div>
                <div className="d-grid smartphone">
                  <button type="button" className="btn btn-primary btn-lg" onClick={(e)=>setTaks(e)}>Enviar a Tasking</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Message ref={msgRef}></Message>
        <Footer />
      </>
    );
}

export default Tasking;